module.exports = __webpack_public_path__ + "static/media/06_360.bdd4c3ee.jpeg";